import { useNavigation, useProvider } from '~/Hooks';
import { Segment } from '../../../../Helpers/Segment.helper';
import { dateDiffInDays } from '../../../../Helpers/Date.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';

export interface UseCalendarNavigationProps {
  focusedDay: Date;
  onNext: () => void;
  onPrev: () => void;
}

export const useCalendarNavigation = ({
  focusedDay,
  onNext,
  onPrev,
}: UseCalendarNavigationProps) => {
  const { navigate } = useNavigation();
  const { currentProvider } = useProvider();

  const domain = currentProvider?.domain || '';

  const handleCreateEvent = () => {
    navigate(routeReplacer(Route.EVENT_CREATE, { domain }));
  };

  const onNextWithTracker = () => {
    Segment.track('click_on_calendar_future', {
      category: 'Calendar',
      weeksIntoTheFuture: `${Math.ceil(dateDiffInDays(new Date(), focusedDay) / 7) + 1}`,
    });
    onNext();
  };

  const onPrevWithTracker = () => {
    Segment.track('click_on_calendar_past', {
      category: 'Calendar',
      weeksIntoThePast: `${Math.ceil(dateDiffInDays(focusedDay, new Date()) / 7) - 1}`,
    });
    onPrev();
  };

  return {
    onNextWithTracker,
    onPrevWithTracker,
    handleCreateEvent,
  };
};
